import { CommonWeekdayEnumResponse } from '@/api/services/common/weekdays/common-weekdays.dto'
import { ConfigurationPersonnelWeekdayAssignmentResponse } from '@/modules/configurationModule/detail/automation/personnel/entities-association/services/configuration-personnel-weekday-assignment/configuration-personnel-weekday-assignment.dto'
import { store } from '@/store/store'

export interface ConfigurationAutomationPersonnelEntitiesAssociationModalWeekdayAssignmentFormState {
    weekdays: CommonWeekdayEnumResponse[]
    personnelWeekdayAssignments: ConfigurationPersonnelWeekdayAssignmentResponse[]
    laboratoryId: number
}
export const initialConfigurationAutomationPersonnelEntitiesAssociationModalWeekdayAssignmentFormState =
    (): ConfigurationAutomationPersonnelEntitiesAssociationModalWeekdayAssignmentFormState => ({
        weekdays: [],
        personnelWeekdayAssignments: [],
        laboratoryId: store.getters.labId
    })
